<button
  (click)="handleButtonClick()"
  class="flex items-center w-32 h-32"
  type="button"
>
  <span class="sr-only">Menu</span>

  <ng-container *ngIf="isActive; else hamburger">
    <svg
      class="w-full h-auto"
      width="100%"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3 26L25.6274 3.37258L28.4558 6.20101L5.82843 28.8284L3 26Z" fill="black"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6 3L28.6274 25.6274L25.799 28.4558L3.17157 5.82843L6 3Z" fill="black"/>
    </svg>
  </ng-container>

  <ng-template #hamburger>
    <svg
      class="w-full h-auto"
      width="100%"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.49691e-07 6L32 6V10L0 10L3.49691e-07 6Z" fill="black"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.49691e-07 14L32 14V18L0 18L3.49691e-07 14Z" fill="black"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.49691e-07 22L32 22V26L0 26L3.49691e-07 22Z" fill="black"/>
    </svg>
  </ng-template>
</button>
